/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name rlog.service:Rlog
   *
   * @description
   *
   */
  angular
    .module('vcutils.rlog')
    .service('Rlog', Rlog);
  
  Rlog.$inject = ['vertxEventBusService'];
  
  function Rlog(vertxEventBusService) {
    this.debug = function (module, directive, text, payload) {
      let message = log('debug', module, directive, text, payload);
      console.log('Rlog debug: ', directive, text);
      // return vertxEventBusService.publish('rlog.entry', message);
      return;
    };
    
    this.error = function (module, directive, text, payload) {
      let message = log('error', module, directive, text, payload);
      console.log('Rlog error: ', directive, text);
      return vertxEventBusService.publish('rlog.entry', message);
    };

    function log(level, module, directive, text, payload) {
      let message = {};
      message.level = level;
      message.module = module;
      // noinspection ES6ModulesDependencies
      message.timestamp = moment().toISOString();
      // noinspection ES6ModulesDependencies
      message.fdate = moment().format('YYYY MMM DD (DDD), hh:mm:ss');
      message.directive = directive;
      message.text = text;
      message.payload = payload;
      return message;
    }
    
  }
}());
